module.exports = __webpack_public_path__ + "static/media/slika5.13959e53.png";